/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import { Stethoscope, HeartPulse, HandHeart, UserRound } from 'lucide-react';

export const CATEGORY_META = {
  medici: {
    label: 'medici',
    color: '#1D4ED8',
    soft: '#DBEAFE',
    textOnSoft: '#1E3A8A',
    ring: '#BFDBFE',
    icon: Stethoscope,
    className: 'cat-medici-badge',
  },
  infermieri: {
    label: 'infermieri',
    color: 'var(--wl-primary)',
    soft: '#CCFBF1',
    textOnSoft: '#115E59',
    ring: '#99F6E4',
    icon: HeartPulse,
    className: 'cat-infermieri-badge',
  },
  oss: {
    label: 'oss',
    color: '#B45309',
    soft: '#FEF3C7',
    textOnSoft: '#78350F',
    ring: '#FDE68A',
    icon: HandHeart,
    className: 'cat-oss-badge',
  },
  paziente: {
    label: 'utente-paziente',
    color: '#047857',
    soft: '#D1FAE5',
    textOnSoft: '#065F46',
    ring: '#A7F3D0',
    icon: UserRound,
    className: 'cat-paziente-badge',
  },
};

export const timeAgo = (iso, t) => {
  if (!iso) return '';
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return t('justNow');
  if (diff < 3600) return t('minutesAgo', { count: Math.floor(diff / 60) });
  if (diff < 86400) return t('hoursAgo', { count: Math.floor(diff / 3600) });
  if (diff < 86400 * 7) return t('daysAgo', { count: Math.floor(diff / 86400) });
  return d.toLocaleDateString();
};

export const fileToBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
  reader.readAsDataURL(file);
});

export const extractYoutubeId = (url) => {
  if (!url) return null;
  const m = url.match(/(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  return m ? m[1] : null;
};

// Precomputed once at module load time: pros-only categories (excludes 'paziente').
// Used by FeedPage/FeedbackPage/RegisterPage/etc. to avoid recomputing every render.
export const PROFESSIONAL_CATEGORIES = Object.entries(CATEGORY_META).filter(([key]) => key !== 'paziente');

export const initials = (name) => {
  if (!name) return '?';
  return name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
};
